import * as React from 'react'

import Paper, { PaperProps } from './Paper'
import { cn } from './cn'

export const Card = React.forwardRef<HTMLDivElement, PaperProps>(
  ({ className, ...props }, ref) => (
    <Paper ref={ref} className={cn('overflow-hidden', className)} {...props} />
  ),
)
Card.displayName = 'Card'

export const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('p-4 last:pb-6', className)} {...props} />
))
CardContent.displayName = 'CardContent'

export const CardActions = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex items-center gap-2 p-2', className)}
    {...props}
  />
))
CardActions.displayName = 'CardActions'
